import { useQuery } from 'react-query';
import { chrApi } from '../../api/api';

export function useQMEByApptId(appointmentId, onSuccessCb = () => {}) {
  return useQuery('fetchQMEById', () => chrApi('get', `medical_evaluation/appointment/${appointmentId}`).then((res) => res.data), {
    enabled: !!appointmentId,
    onSuccess: (data) => {
      onSuccessCb(data);
    },
  });
}
